export const SCENARIO_SUMMARY_FAILED = 'Scenario summary fetch was failed.';
export const DEFAULT_PAGINATION_PROPS = {
  current: 1,
  pageSize: 20
};
